export const SET_TOOLBOX_PRODUCTS = 'SET_TOOLBOX_PRODUCTS'
export const RESET_TOOLBOX_PRODUCTS = 'RESET_TOOLBOX_PRODUCTS'
export const SET_TECHNOLOGIES = 'SET_TECHNOLOGIES'
export const RESET_TECHNOLOGIES = 'RESET_TECHNOLOGIES'